export default {
    data(){
      return {
        breadcrumb: [{ label: "Trung tâm trợ giúp", path: "/docs"}, { label: "Mã nhúng", path: "/docs/embed"}],
        modalTitle: '',
        modalImages: []
      };
    },

    methods: {
      openImage(title, src){
        this.modalTitle = title;
        this.modalImages = src;
        this.$refs.img.show();
      },

      closeImage() {
        this.modalTitle = '';
      }
    },
  };